import { KeyValueConfig } from './KeyValueConfig';

export class GlobalConfig {

  public config: KeyValueConfig[] = [];
  public socialLoginConfig: KeyValueConfig[] = [];

}
